"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageCropperModel = (function () {
    function ImageCropperModel() {
    }
    return ImageCropperModel;
}());
exports.ImageCropperModel = ImageCropperModel;
//# sourceMappingURL=imageCropperModel.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-cropper/src/model/imageCropperModel.js
// module id = 975
// module chunks = 26